module.exports = __webpack_public_path__ + "img/merac.1c57abb1.svg";